import { useQuery } from '@apollo/client/react'
import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { GQL_SCORM_MODULE } from '~/gql/scorm-modules/scorm-modules'
import ScormShell from './ScormShell'

/** Commit no-op : la prévisualisation ne persiste aucune progression. */
async function noopCommit() {}

/**
 * Player de prévisualisation (Admin/Formateur) : joue un module directement
 * depuis l'écran de gestion, sans session ni inscription ni tracking.
 */
function ScormModulePreview() {
  const { t } = useTranslation()
  const { moduleId } = useParams()

  const { data, loading } = useQuery(GQL_SCORM_MODULE, {
    variables: { id: moduleId ?? '' },
    skip: !moduleId,
    fetchPolicy: 'network-only',
  })
  const module = data?.scormModule

  return (
    <ScormShell
      loading={loading}
      module={module}
      initialData={null}
      onCommit={noopCommit}
      headerContent={(
        <>
          {module && <span className="text-sm text-neutral-300">{module.title}</span>}
          <span className="rounded-full bg-amber-500/15 px-2 py-0.5 text-xs font-medium text-amber-400">
            {t('scorm.preview.badge')}
          </span>
        </>
      )}
      headerRight={(
        <div className="flex items-center gap-4">
          <span className="hidden text-xs text-neutral-400 sm:inline">{t('scorm.preview.noTracking')}</span>
          <Link to="/back-office/modules" className="flex items-center gap-1.5 text-sm text-neutral-300 hover:text-white">
            <ArrowLeft className="size-4" />
            {t('scorm.preview.backToModules')}
          </Link>
        </div>
      )}
      fallbackTo="/back-office/modules"
      fallbackLabel={t('scorm.preview.backToModules')}
      unavailableMessage={t('scorm.preview.unavailable')}
    />
  )
}

export default ScormModulePreview
